import type {
  Artifact,
  ImageArtifactReference,
  SBOMArtifactReference,
} from '@features/applications/applications.models';

/**
 * ArtifactType represents the classification of an artifact.
 *
 * Note: This is a temporary static enum. Once the Platform API provides this,
 * it should be replaced.
 */
export enum ArtifactType {
  Image = 'image',
  SBOM = 'sbom',
  Source = 'source',
}

export const isImageArtifact = (
  artifact: Artifact,
): artifact is Artifact & { reference: ImageArtifactReference } =>
  artifact.type === ArtifactType.Image;

export const isSbomArtifact = (
  artifact: Artifact,
): artifact is Artifact & { reference: SBOMArtifactReference } =>
  artifact.type === ArtifactType.SBOM;
